import { getIn } from 'formik';

import { isEqual } from '../collections/array-utils';

export const getInitialValue = (value) => {
  if (![null, undefined].includes(value)) {
    return value;
  }
  return null;
};

export const getFormikValue = (value) => {
  if (![null, undefined].includes(value)) {
    return value;
  }
  return '';
};

export const isDisplayShrink = (value) => {
  if (![null, undefined, ''].includes(value)) {
    return true;
  }
  return false;
};

export const onChangeWithInitReturn =
  (name, formik, isNumber = false, onChange = null) =>
  (e) => {
    const initValue = formik.initialValues[name];
    const value =
      e.target.value === '' && (!initValue || initValue === '')
        ? initValue
        : e.target.value;

    let result = value || null;

    if (isNumber) {
      if (value && value.endsWith('.')) {
        result = value;
      } else if (value && value !== '-') {
        result = parseFloat(value);
      }
    }
    if (isNumber && isNaN(result)) {
      return;
    }

    formik.setTouched({ ...formik.touched, [name]: true }, false);

    if (onChange) onChange(result);
    else formik.setFieldValue(name, result, true);
  };

export function checkIsFormikPropsAreEqual(
  prevProps,
  nextProps,
  fieldName = '',
) {
  return (
    isEqual(
      getIn(prevProps.formik.values, fieldName),
      getIn(nextProps.formik.values, fieldName),
    ) &&
    isEqual(
      getIn(prevProps.formik.errors, fieldName),
      getIn(nextProps.formik.errors, fieldName),
    ) &&
    isEqual(
      getIn(prevProps.formik.touched, fieldName),
      getIn(nextProps.formik.touched, fieldName),
    )
  );
}
